import * as R from 'ramda';

// userRoles constants to be used throughout app, ex:
export const userPermissions = {
  ADMIN: process.env.REACT_APP_ADMIN,
  DISPATCHING_MANAGE: 'CASR-Dispatching: Manage',
  DISPATCHING_VIEW: 'CASR-Dispatching: View',
  IDENTITY_ADMIN: 'Identity-Admin',
  PRODUCT_LOADING_MANAGE: 'CASR-Product-Loading: Manage',
  PRODUCT_LOADING_VIEW: 'CASR-Product-Loading: View',
  PRODUCT_OWNERSHIP_MANAGE: 'CASR-Product-Ownership: Manage',
  PRODUCT_OWNERSHIP_VIEW: 'CASR-Product-Ownership: View',
  PRODUCT_SHIPPING_MANAGE: 'CASR-Product-Shipping: Manage',
  PRODUCT_SHIPPING_VIEW: 'CASR-Product-Shipping: View',
  USER: 'CASR-User',
};

export const affiliatePermissions = {
  CARRIER: 'carrier',
  INVENTORY_OWNER: 'inventoryOwner',
  REFINER: 'refiner',
  SHIPPER: 'shipper',
  SUBSCRIBER: 'hasActiveSubscription',
  SUPPLIER: 'supplier',
};

export const userRoles = { ...userPermissions, ...affiliatePermissions };
export const hasAllRoles = R.curry((reqRoles, roles) => R.all(R.includes(R.__, roles))(reqRoles));
export const hasAnyRoles = R.curry((reqRoles, roles) => R.any(R.includes(R.__, roles))(reqRoles));
// Leave these here for the time being, considerations for future changes
// or removing these functions all together
// export const hasAllRoles = R.curry((reqRoles, roles) =>
//   R.equals(R.length(reqRoles), R.length(R.intersection(reqRoles, R.values(roles))))
// );
// export const hasAnyRoles = R.curry((reqRoles, roles) =>
//   R.isEmpty(R.intersection(reqRoles, R.or(R.values(roles), roles)))
// );
export const hasAnyAndAllRoles = R.curry(({ any, all }, roles) =>
  R.both(hasAllRoles(all), hasAnyRoles(any))(roles)
);
